/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Form,
  Radio,
  Modal,
  Loader,
  Button
} from 'semantic-ui-react';
import { reaction } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import DatesRangeInput from '../DatesRangeInput/DatesRangeInput';
import CreateJiraIssueSettingModalWithCS from '../Jira/CreateJiraIssueSettingModalWithCS';
import WithRouter from '../Extensions/WithRouter';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';

function ContinuousScanSetting(props) {
  const { t, state } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [isOpenModal, setModal] = useState(false);
  const [isOpenMCI, setIsOpenMCI] = useState(false);
  const [hasJira, setHasJira] = useState(false);
  const [period, setPeriod] = useState('unlimitied');
  const [rangeEnd, setRangeEnd] = useState('');
  const [rangeStart, setRangeStart] = useState('');
  const [useContinuousScan, setIsUseContinuousScan] = useState(false);
  const [datesRange, setDatesRange] = useState('');
  const [modalAction, setModalAction] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [isRealUse, setRealUse] = useState(false);

  const formatDateToKr = (date) => {
    const currentLocale = localStorage.getItem('i18nextLng');
    const [year, month, day] = date.split('-');

    if (currentLocale === 'kr' || currentLocale === 'ja') {
      return date;
    } if (currentLocale === 'en') {
      return `${year}-${month}-${day}`;
    }
    throw new Error('Unsupported locale');
  };

  const formatDateByLocale = (date) => {
    const currentLocale = localStorage.getItem('i18nextLng');

    let [year, month, day] = date.split('-');

    if (year.length === 2) {
      [day, month, year] = date.split('-');
    }

    if (currentLocale === 'kr' || currentLocale === 'ja') {
      return `${year}-${month}-${day}`;
    }

    if (currentLocale === 'en') {
      return `${day}-${month}-${year}`;
    }

    throw new Error('Unsupported locale');
  };

  const getContinuousScanSettings = useCallback(() => {
    api
      .getContinuousScanSettings()
      .then((response) => {
        const res = convertPropertiesToCamelCase(response.response);

        setHasJira(res.hasJira);
        setPeriod(res.period);
        setRangeEnd(res.rangeEnd);
        setRangeStart(res.rangeStart);
        if (res.period === 'custom_range') {
          const newDate = `${formatDateByLocale(res.rangeStart)} - ${formatDateByLocale(res.rangeEnd)}`;
          setDatesRange(newDate);
        }
        setIsUseContinuousScan(res.useContinuousScan);
        setRealUse(res.useContinuousScan);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  const handleButtonToggle = (e) => {
    if (e.target.text === t('system.button.on')) {
      if (useContinuousScan) return;
      setIsUseContinuousScan(true);
    } else {
      if (!useContinuousScan) return;
      setIsUseContinuousScan(false);
    }
  };

  const handleCheckChange = (e, { value }) => {
    setPeriod(value);
  };

  const handleDateRange = (event, { value }) => {
    setDatesRange(value);
  };

  const handleMCIOpen = () => {
    if (!isRealUse) {
      setModalAction(t('modal.title.attention'));
      setModalBody(t('settings.message.use_jira_warning'));
      setIsAlert(true);
      setModal(true);
      return;
    }
    setIsOpenMCI(true);
  };

  const closeModal = () => {
    setModal(false);
    setIsAlert(false);
    setIsOpenMCI(false);
  };

  const isValidDateFormat = (date) => {
    const currentLocale = localStorage.getItem('i18nextLng');
    const formatPattern = currentLocale === 'kr' || currentLocale === 'ja'
      ? /^\d{4}-\d{2}-\d{2}$/ // YYYY-MM-DD
      : /^\d{2}-\d{2}-\d{4}$/; // DD-MM-YYYY

    return formatPattern.test(date);
  };

  const updateScanSettings = () => {

    const data = {
      use_continuous_scan: useContinuousScan,
    };

    if (period === 'custom_range') {
      const currentLocale = localStorage.getItem('i18nextLng');

      if (!datesRange || datesRange.trim() === '') {
        setModalAction(t('modal.title.attention'));
        setModalBody(t('settings.message.select_day_required'));
        setIsAlert(true);
        return;
      }

      let startDate;
      let endDate;

      try {
        [startDate, endDate] = datesRange.split(' - ');
      } catch (error) {
        setModalAction(t('modal.title.attention'));
        setModalBody(t('settings.message.invalid_day'));
        setIsAlert(true);
        return;
      }

      if (!isValidDateFormat(startDate) || !isValidDateFormat(endDate)) {
        setModalAction(t('modal.title.attention'));
        setModalBody(t('settings.message.invalid_day'));
        setIsAlert(true);
        return;
      }

      data.period = period;
      data.range_start = formatDateToKr(startDate);
      data.range_end = formatDateToKr(endDate);
    } else {
      data.period = period;
    }

    api
      .setContinuousScanSettings(data)
      .then((response) => {
        const res = convertPropertiesToCamelCase(response.response);
        setPeriod(res.period);
        setRangeEnd(res.rangeEnd);
        setRangeStart(res.rangeStart);
        if (res.period === 'custom_range') {
          const newDate = `${formatDateByLocale(res.rangeStart)} - ${formatDateByLocale(res.rangeEnd)}`;
          setDatesRange(newDate);
        }
        setIsUseContinuousScan(res.useContinuousScan);
        setRealUse(res.useContinuousScan);
        setIsLoading(false);
        setModal(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setModalAction(t('modal.title.attention'));
        setModalBody(t('settings.message.user_not_permitted'));
        setIsAlert(true);
      });
  };

  const handleSaveModal = () => {
    setModalAction(t('modal.title.attention'));
    setModalBody(t('settings.message.save_setting'));
    setModal(true);
  };

  const handleJiraIssueCallback = () => {
    setIsOpenMCI(false);
    getContinuousScanSettings();
  };

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    if (isLoading) {
      getContinuousScanSettings();
    }
  });

  useEffect(() => {
    const dispose = reaction(
      () => { return state.user.localeParams; },
      (localeParams) => {
        if (period === 'custom_range') {
          if (!datesRange || datesRange.indexOf(' - ') === -1) return;

          const [startDate, endDate] = datesRange.split(' - ');

          const formattedStartDate = formatDateByLocale(startDate);
          const formattedEndDate = formatDateByLocale(endDate);

          setDatesRange(`${formattedStartDate} - ${formattedEndDate}`);
        }
      }
    );

    return () => { return dispose(); };
  }, [datesRange, state.user.localeParams, period]);

  const currentLocale = localStorage.getItem('i18nextLng');

  const renderIfReady = (element) => {
    return isLoading ? (
      <div className="loader_container">
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('list.title.loading')}
        </Loader>
      </div>
    ) : (
      element
    );
  };

  return (
    <div className="setting_issue_main" style={{ position: 'relative' }}>
      <div className="contents_header">
        <div className="contents_header_inner">
          <h3 className="content_title">{t('settings.list.continuous_scan_setting')}</h3>
        </div>
        <div className="button_wrap util_item">
          {
            hasJira ? (
              <Button
                className="jira"
                onClick={handleMCIOpen}
                onKeyUp={handleMCIOpen}
              >
                <span className="icon-wrap">
                  <img className="icon-jira" src={JiraLogo} alt="" />
                </span>
                {t('settings.list.edit_jira_settings')}
              </Button>
            ) : (
              <Button
                className="jira"
                onClick={handleMCIOpen}
                onKeyUp={handleMCIOpen}
              >
                <span className="icon-wrap">
                  <img className="icon-jira" src={JiraLogo} alt="" />
                </span>
                {t('settings.list.create_jira_settings')}
              </Button>
            )
          }
        </div>
      </div>
      {
        renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              <h3>
                {t('settings.list.continuous_scan_sub_title')}
              </h3>
              <div className="setting_issues_content_item">
                {
                  state.user.isAdmin ? (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: useContinuousScan,
                          }
                        )}
                        onClick={handleButtonToggle}
                        onKeyUp={handleButtonToggle}
                      >
                        {t('system.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !useContinuousScan,
                          }
                        )}
                        onClick={handleButtonToggle}
                        onKeyUp={handleButtonToggle}
                      >
                        {t('system.button.off')}
                      </a>
                    </div>
                  ) : (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: useContinuousScan,
                          },
                          'disable'
                        )}
                      >
                        {t('system.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !useContinuousScan,
                          },
                          'disable'
                        )}
                      >
                        {t('system.button.off')}
                      </a>
                    </div>
                  )
                }
                {
                  useContinuousScan ? (
                    <p className="text">
                      {t('settings.message.use_continuous_scan')}
                    </p>
                  ) : (
                    <p className="text">
                      {t('settings.message.not_use_continuous_scan')}
                    </p>
                  )
                }
              </div>
            </div>
            {
              useContinuousScan
            && (
              <Form className="setting_form">
                <h3>
                  {t('settings.list.continuous_scan_period')}
                </h3>
                <Form.Group className="setting_form_group">
                  <Form.Field>
                    <Radio
                      label={t('settings.list.period_all')}
                      value="unlimited"
                      checked={period === 'unlimited'}
                      onChange={handleCheckChange}
                      readOnly={!state.user.isAdmin}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Radio
                      label={t('settings.list.period_month_3')}
                      value="month_3"
                      checked={period === 'month_3'}
                      onChange={handleCheckChange}
                      readOnly={!state.user.isAdmin}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Radio
                      label={t('settings.list.period_month_6')}
                      value="month_6"
                      checked={period === 'month_6'}
                      onChange={handleCheckChange}
                      readOnly={!state.user.isAdmin}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Radio
                      label={t('settings.list.period_month_12')}
                      value="month_12"
                      checked={period === 'month_12'}
                      onChange={handleCheckChange}
                      readOnly={!state.user.isAdmin}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Radio
                      label={t('settings.list.period_custom_range')}
                      value="custom_range"
                      checked={period === 'custom_range'}
                      onChange={handleCheckChange}
                      readOnly={!state.user.isAdmin}
                    />

                    <div className="date_range_picker_wrap">
                      {
                        period === 'custom_range'
                      && (
                        <DatesRangeInput
                          className="date_range"
                          name="datesRange"
                          placeholder={t('contents_header.place_holder.from_to')}
                          value={datesRange}
                          iconPosition="left"
                          onChange={handleDateRange}
                          closable
                          disabled={!state.user.isAdmin}
                          dateFormat={currentLocale === 'kr' || currentLocale === 'ja' ? 'YYYY-MM-DD' : 'DD-MM-YYYY'}
                          closeOnMouseLeave={false}
                        />
                      )
                      }
                    </div>
                  </Form.Field>
                </Form.Group>
              </Form>
            )
            }
            {
              state.user.isAdmin
              && (
                <div className="setting_issues_bottom" style={{ bottom: '-260px', position: 'absolute' }}>
                  <a
                    className="save"
                    onClick={handleSaveModal}
                    onKeyUp={handleSaveModal}
                  >
                    {t('modal.button.save')}
                  </a>
                </div>
              )
            }
          </div>
        )
      }
      <Modal open={isOpenModal} onClose={closeModal}>
        <div className="modal_popup_wrap confirm_wrap">
          <div className="modal_popup_box confirm_box">
            <div className="modal_popup confirm">
              <h2 className="title">{modalAction}</h2>
              <p className="text">{modalBody}</p>
              {
                isAlert ? (
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      style={{ cursor: 'pointer' }}
                      onClick={closeModal}
                      onKeyUp={closeModal}
                    >
                      {t('modal.button.ok')}
                    </a>
                  </div>
                ) : (
                  <div className="button_wrap">
                    <a className="left_button" onClick={closeModal} onKeyUp={closeModal}>
                      {t('modal.button.cancel')}
                    </a>
                    <a className="right_button" onClick={updateScanSettings} onKeyUp={updateScanSettings}>
                      {t('modal.button.save')}
                    </a>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </Modal>
      <CreateJiraIssueSettingModalWithCS
        isOpenMCI={isOpenMCI}
        closeModal={closeModal}
        completeCallback={handleJiraIssueCallback}
        translate={t}
        hasJira={hasJira}
      />
    </div>
  );
}

export default WithRouter(withTranslation()(inject('state')(observer(ContinuousScanSetting))));
